<template>
    <div class="row" v-if="show" :id="componentId">
        <div class="col-12 mb-4 text-center">
            <span class="loader d-inline-block float-none align-middle"></span>
            <span class="fa fa-spinner fa-spin"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'infinite-scroll',

        props: {
            show: {required: false, default: true},
        },

        data() {
            return {
                componentId: 'inf-scroll-' + Date.now() + new Date().getUTCMilliseconds() // Get a unique ID for every component
            }
        },

        methods: {
            // Returns true when this infinite scroll component is shown and visible
            infiniteScrollVisible() {
                const scrollY = window.scrollY
                const visible = document.documentElement.clientHeight
                const element = document.getElementById(this.componentId)
                let elementOffsetTop = document.documentElement.scrollHeight - 40

                // If the element is found and the browser-function to calculate it's offset is available: use that
                // If not: the fallback scrollHeight off the browser is used
                if (element && typeof element.getBoundingClientRect === 'function') {
                    elementOffsetTop = element
                        .getBoundingClientRect().top
                        + document.documentElement.scrollTop
                        - 20 // Start loading just before the bottom
                }

                return (visible + scrollY >= elementOffsetTop) && this.show
            },
        },

        mounted() {
            window.addEventListener('scroll', () => {
                if (this.infiniteScrollVisible()) {
                    this.$emit('next')
                }
            })
        }

    }
</script>
